import { createFileRoute } from '@tanstack/react-router';
import CorrectiveActions from 'src/pages/Organization/Reports/CorrectiveActions';

export const Route = createFileRoute(
  '/$organizationSlug/reports/corrective_actions/',
)({
  component: CorrectiveActions,
});
